export class PasswordReset {
  username: string | null = "";
  password: string = "";
  confirmPassword: string = "";
  token: string = "";

  constructor() { }
}
